/**
 * Shown when an uploaded PDF is structurally unusable (e.g. truncated before
 * its trailer). Viewers may still render it, so the message explains the
 * "looks fine but is broken" case and the real fix. This module is a
 * dependency-free leaf, so both the server-side guards and the Oak upload hook
 * import it directly (no pdf-lib pulled into the web bundle).
 */
export const INCOMPLETE_PDF_MESSAGE =
  "This PDF is incomplete or corrupted and can't be processed for mailing, " +
  "even though it may open normally. Please obtain a fresh copy of the file " +
  "from the source and attach that.";
